module.exports = __webpack_public_path__ + "static/tab02-f6b3d0338a52f0d9d8f347732b021a77.png";